module.exports = __webpack_public_path__ + "img/carmap.9dd6cc15.png";